var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Previous",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.342851 5.11111C0.342851 5.27344 0.411601 5.42622 0.529459 5.5408L4.92946 9.81858C5.04732 9.93316 5.20446 10 5.37143 10C5.71518 10 6 9.72309 6 9.38889L6 0.833333C6 0.499132 5.71518 0.222222 5.37143 0.222222C5.20446 0.222222 5.04732 0.289062 4.92946 0.403646L0.529459 4.68142C0.411601 4.79601 0.342851 4.94878 0.342851 5.11111Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/Previous.887359facb9842d4edc9cfaa5ad5dda3.svg";
export { ForwardRef as ReactComponent };